// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import checkoutSharedStyles from "@turnerBlueprint/App/SharedStyles/CheckoutStyles";
import { billingAndShippingStyles } from "@turnerBlueprint/Overrides/Widgets/OnePageCheckoutConfirmation/OnePageCheckoutConfirmationBillingAndShipping";
import { fontConfig } from "@turnerBlueprint/XDL/PreStyle/typography";
import { css } from "styled-components";

billingAndShippingStyles.container = checkoutSharedStyles.container;
billingAndShippingStyles.section = checkoutSharedStyles.section;

billingAndShippingStyles.shipToTitleText = {
    variant: "h3",
};
billingAndShippingStyles.pickUpTitleText = {
    variant: "h3",
};
billingAndShippingStyles.deliveryMethodTitleText = {
    variant: "h3",
};

billingAndShippingStyles.deliveryMethodText = {
    size: 14,
    lineHeight: "22px",
    css: css`
        margin-bottom: 8px;
        display: block;
    `,
};

billingAndShippingStyles.notesSection = {
    css: css`
        margin-top: 20px;
    `,
};

billingAndShippingStyles.notesTitleText = {
    size: 14,
    lineHeight: "16px",
    weight: fontConfig.weight.bold,
    css: css`
        margin-bottom: 8px;
        display: block;
    `,
};

billingAndShippingStyles.notesText = {
    size: 14,
    lineHeight: "22px",
    css: css`
        ${wrapInContainerStyles}
    `,
};
